export const PB_STATION_STATUSES = {
  ACTIVE: "ACTIVE",
  GARAGE: "GARAGE",
  BROKEN: "BROKEN",
  LOST: "LOST"
};

export const PM_STATION_TYPES = {
  RELINK: "RELINK"
};

export const PM_STATION_NETWORK_MODES = {
  WIFI: "WIFI",
  I_2G: "I_2G",
  I_3G: "I_3G",
  I_4G: "I_4G"
};



// WEBPACK FOOTER //
// ./src/views/pages/chargers/stations/constants.js